import { ArrowBackRounded, RedeemOutlined } from "@mui/icons-material";
import { Box, Card, IconButton, Tab, Tabs, Typography } from "@mui/material";
import { PropsWithChildren } from "react";
import { useSearchParams } from "react-router-dom";
import { black, greyEnabled, purple, purpleLight } from "../../theme/colors";

const TAB_SUBTITLES = [
  "Manage user reward points and redemptions.",
  "Review and pay out rewards users have requested to redeem.",
];

interface RewardsLayoutProps {
  page?: number;
  setPage?: (page: number) => void;
  currentTab?: number;
  onTabChange?: (tab: number) => void;
}

export default function RewardsLayout({
  children,
  setPage,
  page,
  currentTab = 0,
  onTabChange,
}: PropsWithChildren<RewardsLayoutProps>) {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleBackClick = () => {
    const currPage = Number(searchParams.get("page")) || 1;

    if (currPage > 1) {
      const newPage = currPage - 1;
      setPage?.(newPage);
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev);
          params.set("page", newPage.toString());
          return params;
        },
        { replace: true }
      );
    }
  };

  return (
    <Box display={"flex"} mt={4}>
      <Card
        elevation={0}
        sx={{
          display: "flex",
          width: "100%",
          minHeight: 600,
          mb: 2,
          borderRadius: 3,
          border: "1px solid #ECECEC",
        }}
      >
        <Box display="flex" flexDirection={"column"} sx={{ width: "100%" }}>
          <Box
            sx={{
              borderBottom: "1px solid #ECECEC",
              p: { xs: 2.5, sm: 3 },
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              {page !== undefined && page > 1 && (
                <IconButton onClick={handleBackClick}>
                  <ArrowBackRounded />
                </IconButton>
              )}
              <Box display="flex" alignItems="center" gap={1.5}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 44,
                    height: 44,
                    borderRadius: 2,
                    bgcolor: purpleLight,
                    flexShrink: 0,
                  }}
                >
                  <RedeemOutlined sx={{ color: purple, fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography variant="h5" fontWeight={700} color={black}>
                    Rewards
                  </Typography>
                  <Typography variant="body2" color={greyEnabled}>
                    {TAB_SUBTITLES[currentTab]}
                  </Typography>
                </Box>
              </Box>
            </Box>
            {onTabChange && (
              <Tabs
                value={currentTab}
                onChange={(_, value) => onTabChange(value)}
                sx={{ mt: 2 }}
                TabIndicatorProps={{
                  style: { backgroundColor: purple, height: 3, borderRadius: 3 },
                }}
              >
                <Tab
                  label="Reward Points"
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    color: greyEnabled,
                    "&.Mui-selected": { color: purple },
                  }}
                />
                <Tab
                  label="User Requested Rewards"
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    color: greyEnabled,
                    "&.Mui-selected": { color: purple },
                  }}
                />
              </Tabs>
            )}
          </Box>
          {children}
        </Box>
      </Card>
    </Box>
  );
}
